import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	TextField,
	FormControl,
	Typography,
	ListItemIcon,
	DialogActions,
	Button,
	Popover,
} from "@mui/material";
import { InsertEmoticon } from "@mui/icons-material";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { useAddSubcategoryMutation } from "../../../services/queryHooks";
import { validateTextField } from "../../../utils/validation";

export default function AddCategoryModal({ isOpen, onClose, categoryGroup }) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [emoji, setEmoji] = useState(null);
	const [name, setName] = useState("");
	const [errorName, setErrorName] = useState("");
	const { t } = useTranslation();
	const { mutate, isError, error, reset } = useAddSubcategoryMutation();

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleCloseEmojiPopup = () => {
		setAnchorEl(null);
	};

	const handleEmojiSelect = (emoji) => {
		setEmoji(emoji.native);
		handleCloseEmojiPopup();
	};

	const validateInputs = () => {
		let isValid = true;
		setErrorName("");
		const textError = validateTextField(name, t, {
			fieldName: t("categoryName"),
		});

		if (textError) {
			setErrorName(textError);
			isValid = false;
		} else if (
			categoryGroup.subcategories.some(
				(subcat) =>
					(subcat.name || t(subcat.translationKey)).toLowerCase() ===
					name.trim().toLowerCase()
			)
		) {
			setErrorName(t("categoryNameExistsError"));
			isValid = false;
		}
		return isValid;
	};

	const handleCloseModal = () => {
		setName("");
		setErrorName("");
		setEmoji(null);
		reset();
		onClose();
	};

	const submitForm = (event) => {
		event.preventDefault();
		if (errorName) return;
		mutate({
			categoryGroupId: categoryGroup._id,
			name: name,
			emoji: emoji,
		});
		handleCloseModal();
	};

	return (
		<>
			<Dialog open={isOpen} onClose={onClose} disableEnforceFocus>
				<DialogTitle>
					{t("addCategoryToTheGroup") +
						": " +
						(categoryGroup.groupName
							? categoryGroup.groupName
							: t(categoryGroup.groupTranslationKey))}
				</DialogTitle>
				<form noValidate onSubmit={submitForm}>
					<DialogContent>
						<TextField
							autoFocus
							label={t("name")}
							type="text"
							fullWidth
							value={name}
							onChange={(e) => setName(e.target.value)}
							error={errorName ? true : false}
							helperText={errorName}
						/>
						<FormControl
							sx={{
								mt: 2,
								display: "flex",
								flexDirection: "row",
							}}
						>
							<Typography
								component="span"
								variant="subtitle1"
								gutterBottom
							>
								{t("pickCategoryIcon") + ":"}
							</Typography>
							<ListItemIcon
								sx={{
									cursor: "pointer",
									minWidth: "auto",
									color: "inherit",
									mr: 1,
								}}
								onClick={(e) => handleClick(e)}
							>
								{emoji ? (
									<span
										style={{ fontSize: 22, color: "null" }}
									>
										{emoji}
									</span>
								) : (
									<InsertEmoticon
										sx={{ width: "30.36px", ml: 1 }}
									/>
								)}
							</ListItemIcon>
						</FormControl>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleCloseModal}>
							{t("cancel")}
						</Button>
						<Button
							type="submit"
							variant="contained"
							onClick={validateInputs}
						>
							{t("save")}
						</Button>
						{isError && <p>Błąd: {error.message}</p>}
					</DialogActions>
				</form>
				<Popover
					disableEnforceFocus
					open={Boolean(anchorEl)}
					anchorEl={anchorEl}
					onClose={handleCloseEmojiPopup}
					anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
				>
					<Picker
						data={data}
						onEmojiSelect={handleEmojiSelect}
						previewPosition="none"
					/>
				</Popover>
			</Dialog>
		</>
	);
}
